import { JobChange } from "@webmonitoring/vp-common";
import { JobHistory, JobGetResponse } from "@/types/job";
// @ts-ignore
import { Crop } from "react-image-crop";

interface ToSerializedCropOptions {
  crop?: Crop;
}

export const toSerializedCrop = (options: ToSerializedCropOptions) => {
  return options.crop ? `${options.crop.x},${options.crop.y},${options.crop.width},${options.crop.height}` : "";
};

interface ToUnserializedCropOptions {
  crop?: Crop | string;
}

export const toUnserializedCrop = (options: ToUnserializedCropOptions) => {
  const crop = typeof options?.crop === "string" ? options.crop : toSerializedCrop({ crop: options.crop });

  const [x = 0, y = 0, width = 0, height = 0] = crop?.split(",").map(Number) ?? [];

  return {
    height,
    width,
    x,
    y,
  };
};

interface ToPixelsCropOptions {
  crop?: Crop | string;
}

export const toPixelsCrop = (options: ToPixelsCropOptions): Crop => {
  const { height, width, x, y } = toUnserializedCrop({ crop: options.crop });

  return {
    height,
    unit: "px",
    width,
    x,
    y,
  };
};

interface ToPercentCropOptions {
  crop?: Crop | string;
  target: {
    height: number;
    width: number;
  };
}

export const toPercentCrop = (options: ToPercentCropOptions): Crop => {
  const { height, width, x, y } = toUnserializedCrop({ crop: options.crop });

  return {
    height: Math.round((height / options.target.height) * 100),
    unit: "%",
    width: Math.round((width / options.target.width) * 100),
    x: Math.round((x / options.target.width) * 100),
    y: Math.round((y / options.target.height) * 100),
  };
};

interface GetCombinedJobHistoryOptions {
  job?: JobGetResponse;
  limit?: number;
}

interface CombinedJobHistoryItem {
  changes?: JobChange;
  history?: JobHistory;
}

export const getCombinedJobHistory = ({ job }: GetCombinedJobHistoryOptions) => {
  const jobHistory =
    job?.history?.map((item) => {
      return { history: item };
    }) ?? [];

  const jobChanges =
    job?.changes?.map((item) => {
      return { changes: item };
    }) ?? [];

  const combinedJobHistoryMap = [...jobHistory, ...jobChanges].reduce<{
    [index: string]: CombinedJobHistoryItem;
  }>((result, item) => {
    const processId =
      "history" in item ? item?.history?.process_id : "changes" in item ? String(item?.changes?.process_id) : undefined;

    if (!processId) {
      return result;
    } else {
      const match = result[processId];

      if (match) {
        result[processId] = {
          ...match,
          ...item,
        };

        return result;
      } else {
        result[processId] = item;

        return result;
      }
    }
  }, {});

  return Object.values(combinedJobHistoryMap).sort((itemA, itemB) => {
    const dateA = itemA?.history?.created ?? itemA?.changes?.created ?? "";
    const dateB = itemB?.history?.created ?? itemB?.changes?.created ?? "";

    return new Date(dateB).valueOf() - new Date(dateA).valueOf();
  });
};
